<template>
  <div class="w-full h-auto py-[3.75vw] bg-[#F5F5F7;]">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-full flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          合作单位
        </div>
      </div>
    </div>

    <!-- 合作单位容器 -->
    <div
      class="relative left-1/2 -translate-x-1/2 w-[61.46vw] flex flex-col gap-[1.77vw]"
    >
      <!-- 添加遮罩容器 -->
      <div
        class="absolute inset-y-0 left-[-1vw] w-[10%] z-20 pointer-events-none"
      >
        <div
          class="h-full bg-gradient-to-r from-[#F5F5F7] to-transparent"
        ></div>
      </div>
      <div
        class="absolute inset-y-0 right-[-1vw] w-[10%] z-20 pointer-events-none"
      >
        <div
          class="h-full bg-gradient-to-l from-[#F5F5F7] to-transparent"
        ></div>
      </div>
      <!-- 每行容器 -->
      <div
        v-for="(group, index) in cooperateGroups"
        :key="index"
        class="overflow-hidden"
      >
        <!-- 滚动内容容器 -->
        <div
          :class="[
            'flex gap-[1.77vw] whitespace-nowrap min-w-[200%]',
            index === 1 ? 'animate-scroll-left' : 'animate-scroll-right',
          ]"
        >
          <!-- 双份内容实现无缝滚动 -->
          <template v-for="i in 2">
            <div
              v-for="(item, itemIndex) in group"
              :key="`${index}-${itemIndex}-${i}`"
              class="flex-shrink-0"
            >
              <!-- 单个合作单位 -->
              <div class="flex flex-col gap-[0.83vw] items-center">
                <el-image
                  class="w-[8.96vw] h-[5vw] object-cover"
                  :src="
                    require(`@/assets/images/AboutUs/module5/image${
                      index * 6 + itemIndex + 1
                    }.png`)
                  "
                  :alt="item.name"
                  lazy
                />
                <div
                  class="w-[8.96vw] text-[0.73vw] text-[#1A2233] text-center leading-[1.09vw] font-harmony font-normal"
                  style="white-space: pre-line"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "abouotus-module5",
  data() {
    return {
      cooperateGroups: [
        // 第一行
        [
          {
            name: "中国航空器拥有者及驾驶员协会",
          },
          { name: "中国航空运动协会" },
          { name: "中国民航飞行员协会" },
          { name: "中国航空学会" },
          { name: "陕西省航空运动协会" },
          { name: "陕西省航空学会" },
        ],
        // 第二行
        [
          { name: "西北工业大学" },
          { name: "西安交通大学" },
          { name: "陕西师范大学" },
          { name: "西电实验小学" },
          { name: "莲湖区郝家巷小学" },
          {
            name: "陕西师范大学御锦城小学",
          },
        ],
        // 第三行
        [
          {
            name: "陕西师范大学附属小学\n（雁塔校区）",
          },
          {
            name: "陕西师范大学大兴新区小学",
          },
          { name: "莲湖德杰实验小学" },
          { name: "西安市浐灞第六小学" },
          { name: "西安市浐灞第三小学" },
          { name: "沣东实验小学" },
        ],
      ],
    };
  },
};
</script>

<style scoped>
@keyframes scroll-right {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-52.4%);
  }
}

@keyframes scroll-left {
  from {
    transform: translateX(-52.4%);
  }
  to {
    transform: translateX(0);
  }
}

.animate-scroll-right {
  animation: scroll-right 30s linear infinite;
}

.animate-scroll-left {
  animation: scroll-left 30s linear infinite;
}

/* 在原有样式基础上添加 */
.bg-gradient-to-r {
  background-image: linear-gradient(
    to right,
    #f5f5f7 30%,
    rgba(245, 245, 247, 0.6) 70%,
    rgba(245, 245, 247, 0)
  );
}

.bg-gradient-to-l {
  background-image: linear-gradient(
    to left,
    #f5f5f7 30%,
    rgba(245, 245, 247, 0.6) 70%,
    rgba(245, 245, 247, 0)
  );
}
</style>